// How ⌘K matches what it does not get ranked by the server: every typed word starts a word of the label or of the
// keywords, or the initials of words in a row ("po", Purchase orders). cmdk's own filter matched letters in order
// anywhere, so "roles" also kept Hilldun approvals and Orders from Joor (ACC-11).

const LABEL_START = 1;
const IN_LABEL = 0.8;
const IN_KEYWORDS = 0.5;

const fold = (text: string) => text.normalize("NFD").replace(/\p{M}/gu, "").toLocaleLowerCase();

const wordsOf = (text: string) =>
  fold(text)
    .split(/[^\p{L}\p{N}]+/u)
    .filter(Boolean);

const startsAWord = (words: string[], typed: string) =>
  words.some((word, i) => word.startsWith(typed) || initialsFrom(words, i).startsWith(typed));

const initialsFrom = (words: string[], from: number) =>
  words
    .slice(from)
    .map((word) => word[0])
    .join("");

/** 0 hides the item; otherwise the higher, the sooner (cmdk sorts by it). */
export function paletteScore(label: string, search: string, keywords: string[] = []): number {
  const typed = wordsOf(search);
  if (typed.length === 0) return LABEL_START;
  const labelWords = wordsOf(label);
  const keywordWords = keywords.flatMap(wordsOf);
  if (!typed.every((word) => startsAWord(labelWords, word) || startsAWord(keywordWords, word))) return 0;
  if (fold(label).startsWith(fold(search).trim())) return LABEL_START;
  return typed.every((word) => startsAWord(labelWords, word)) ? IN_LABEL : IN_KEYWORDS;
}
